import Dependencies from '../../utilities/dependencies';
import CmsApi from '../../utilities/cms-api';
import CategoryFilter from '../../components/category-filter';

/**
 * Library links:
 * 	- https://github.com/atmist/snazzy-info-window
 * 	- https://developers.google.com/maps/documentation/javascript/
 */
export default class PlacesMobile {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.places-element.mobile-view'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [
		[Dependencies.libraries.googleMaps],
		Dependencies.libraries.snazzyInfoWindow,
	];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {Array<any>} */
	#data = [];

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		CmsApi.fetchPlaces().then(places => {
			places.forEach((place) => {
				this.#data.push({
					'id': place.id,
					'name': place.name,
					'slug': place.slug,
					'categories': place.categories,
					'content': place.content,
					'image': place.image,
					'address': place.address,
					'email': place.email,
					'phone': place.phone,
					'website': place.website,
					'latitude': place.latitude,
					'longitude': place.longitude,
					'start': null,
					'end': null,
					'tags': null
				});
			});

			new CategoryFilter(this.#holderElement, this.#data, CategoryFilter.PLACES_TYPE);
		});
	}
}
